import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "promotionContainer" }
const _hoisted_2 = { id: "tabContainer" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }

import { computed, PropType, ref } from 'vue'
import PromotionCard from './components/promotionCardNew.vue'
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user';
import { activityCount, PromotionData, TAB_LIST } from '@/view/promotion/supporrtScript';
import GiftCodeView from '@/view/giftCode/giftCodeView.vue';
import VipView from '@/view/vip/vipView.vue';
import MainFooter from '../components/common/mainFooter.vue';
import { useRouter } from 'vue-router';
import PwaAntiBlockingPopup from '../components/common/pwaAntiBlockingPopup.vue';
import PwaStatusPopup from '../components/common/pwaStatusPopup.vue';
import FundHistory from '@/view/fundHistory/fundHistory.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'promotionPage',
  props: {
    dataSet: {
        type: Object as PropType<PromotionData>,
        required: true
    }
},
  emits: ["openAgentPopup", "openPWAPopup", 'update:show'],
  setup(__props, { expose: __expose, emit: __emit }) {

const userStore = useUserStore()
const router = useRouter()
const { t } = useI18n();
const active = ref(0)
const selectedTabID = ref(0)
const tabList = ref(TAB_LIST)
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const props = __props

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})

const emits = __emit

const openAgentPopup = () => {
    router.push('/agent')
}

const openPWAPopup = () => {
    emits("openPWAPopup")
}
const onClickTab = (data: any) => {
    selectedTabID.value = data.name
}
const isShowCard = (name: string) => {
    if (name === 'pwa_reward') {
        const hasPwaInfo = userStore.PWAConvertData
        if (hasPwaInfo) {
            return true
        } else {
            return false
        }

    } else {
        return true
    }
}
const pwaPoupOpen = () => {
    pwaPopupRef.value.open()
}

const pwaStatusPoupOpen = (title: string) => {
    pwaPopupStatusRef.value.open(title);
}

__expose({
    pwaPoupOpen,
    pwaStatusPoupOpen
})

return (_ctx: any,_cache: any) => {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_tabs, {
          modelValue: active.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
          ellipsis: false,
          onClickTab: onClickTab
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_tab, {
                key: index,
                title: _ctx.$t(item.name),
                name: item.id
              }, null, 8, ["title", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card_list" }, null, -1)),
      (selectedTabID.value == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataSet?.promotionList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (isShowCard(item.name))
                  ? (_openBlock(), _createBlock(PromotionCard, {
                      key: 0,
                      itemData: item,
                      "un-claimed-count": _unref(activityCount)(_unref(userStore).unreadActivityMsgList, item?.id),
                      onOpenAgentPopup: openAgentPopup,
                      onOpenPWA: openPWAPopup
                    }, null, 8, ["itemData", "un-claimed-count"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (selectedTabID.value == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(VipView, { "is-tab-view": true })
          ]))
        : _createCommentVNode("", true),
      (selectedTabID.value == 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(GiftCodeView, { "is-tab-view": true })
          ]))
        : _createCommentVNode("", true),
      (selectedTabID.value == 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(FundHistory, { "is-tab-view": true })
          ]))
        : _createCommentVNode("", true),
      (_unref(userStore).footerComponent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(MainFooter, {
              itemData: _unref(userStore).footerComponent,
              "active-footer": 1
            }, null, 8, ["itemData"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(PwaAntiBlockingPopup, {
      ref_key: "pwaPopupRef",
      ref: pwaPopupRef
    }, null, 512),
    _createVNode(PwaStatusPopup, {
      ref_key: "pwaPopupStatusRef",
      ref: pwaPopupStatusRef
    }, null, 512)
  ], 64))
}
}

})